import React, { useState } from "react";
import './choosecurrency.css'
import image1 from "../assets/Rectangle 7271 (1).png";
import image2 from "../assets/Rectangle 7271 (2).png";
import image3 from "../assets/Rectangle 7271 (3).png";
import image4 from "../assets/Rectangle 7271 (4).png";

const ChooseCurrency = () => {
  const [selectedIndex, setSelectedIndex] = useState(null); // Track the selected image

  const currencyData = [
    {
      title: "Choose Your Currency",
      description:
        "Select the currency you need from a wide range of options. Enter the desired amount, and our live rates ensure you get the best deal instantly.",
      image: image1,
    },
    {
      title: "Provide Your Details",
      description:
        "Fill in your basic details, such as contact information and ID proof, ensuring a seamless and hassle-free transaction.",
      image: image2,
    },
    {
      title: "Select Delivery Option",
      description:
        "Choose between convenient home delivery or pick-up from a nearby store. Delivery charges are calculated in real time.",
      image: image3,
    },
    {
      title: "Relax and Receive",
      description:
        "Sit back and relax! Your currency will be delivered to your doorstep or ready for pick-up as per your preference.",
      image: image4,
    },
  ];

  return (
    <div style={{display: 'flex',flexDirection:'row'}}>
      <div className="stacked-images-container">
        {currencyData.map((item, index) => (
          <div
            key={index}
            className={`stacked-image ${selectedIndex === index ? "active" : ""}`}
            onClick={() => setSelectedIndex(index)}
            style={{
              cursor: "pointer",
              border: selectedIndex === index ? "2px solid #541c9c" : "none",
              padding: "10px",
              borderRadius: "10px",
              zIndex: selectedIndex === index ? 10 : index, 
            }}
          >
            <img
              src={item.image}
              alt={`Currency ${index + 1}`}
              style={{ height: "200px", width: "auto", borderRadius: "10px" }}
            />
          </div>
        ))}
      </div>

      {selectedIndex !== null && (
        <div className="details-container" style={{ marginTop: "20px" }}>
          <h2>{currencyData[selectedIndex].title}</h2>
          <p>{currencyData[selectedIndex].description}</p>
        </div>
      )}
    </div>
  );
};

export default ChooseCurrency;

